import { render, staticRenderFns } from "./ReverseLogistics.vue?vue&type=template&id=5e3250cb"
import script from "./ReverseLogistics.vue?vue&type=script&lang=js"
export * from "./ReverseLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports